import {arIL} from "../Utils/i18n/arIL";
import {enUS} from "../Utils/i18n/enUS";
import {heIL} from "../Utils/i18n/heIL";
import {ruRU} from "../Utils/i18n/ruRU";
import {ptPT} from "../Utils/i18n/ptPT";

// Language code constants
export const LANG_HE_IL = 'heIL';
export const LANG_EN_US = 'enUS';
export const LANG_AR_IL = 'arIL';
export const LANG_RU_RU = 'ruRU';
export const LANG_PT_PT = 'ptPT';

// Browser locale constants
export const LOCALE_HE_IL = 'he-IL';
export const LOCALE_EN_US = 'en-US';
export const LOCALE_AR_IL = 'ar-IL';
export const LOCALE_RU_RU = 'ru-RU';
export const LOCALE_PT_PT = 'pt-PT';

export const languagesMap = {
    [LANG_HE_IL]: heIL,
    [LANG_EN_US]: enUS,
    [LANG_AR_IL]: arIL,
    [LANG_RU_RU]: ruRU,
    [LANG_PT_PT]: ptPT,
};

export const defaultLanguage = LANG_HE_IL

/**
 * Maps browser locale codes to app language codes
 * Supports both full locale (e.g., 'he-IL') and base language (e.g., 'he')
 */
const browserToWeezbeeLanguageMap = {
    'he': LANG_HE_IL,
    'he-il': LANG_HE_IL,
    'en': LANG_EN_US,
    'en-us': LANG_EN_US,
    'ar': LANG_AR_IL,
    'ar-il': LANG_AR_IL,
    'ru': LANG_RU_RU,
    'ru-ru': LANG_RU_RU,
    'pt': LANG_PT_PT,
    'pt-pt': LANG_PT_PT,
    'pt-br': LANG_PT_PT,
};

/**
 * Detects the user's preferred language from browser settings
 * Uses navigator.languages (array of preferred languages) with fallback to navigator.language
 *
 * @returns {string|null} App language code (e.g., 'heIL') or null if no supported language found
 */
export const detectBrowserLanguage = () => {
    const browserLanguages = navigator.languages || [navigator.language];

    for (const lang of browserLanguages) {
        if (!lang) continue;
        const normalizedLang = lang.toLowerCase();
        // Try exact match first (e.g., 'he-IL'), then base language (e.g., 'he')
        const mapped = browserToWeezbeeLanguageMap[normalizedLang] ||
                       browserToWeezbeeLanguageMap[normalizedLang.split('-')[0]];
        if (mapped) return mapped;
    }

    return null; // No supported language found - caller should use defaultLanguage
};

/**
 * Maps app language codes to browser locale codes for date formatting
 * @param {object} params - Parameters object
 * @param {string} params.language - App language code (e.g., 'heIL')
 * @returns {string} Browser locale code (e.g., 'he-IL')
 */
export const getDateLocaleByLanguageCode = ({language}) => {
    const localeMap = {
        [LANG_HE_IL]: LOCALE_HE_IL,
        [LANG_EN_US]: LOCALE_EN_US,
        [LANG_AR_IL]: LOCALE_AR_IL,
        [LANG_RU_RU]: LOCALE_RU_RU,
        [LANG_PT_PT]: LOCALE_PT_PT
    };
    return localeMap[language] || LOCALE_HE_IL;
};

/**
 * Date format options for toLocaleString with date and time
 * Format: DD.MM.YYYY, HH:MM
 */
export const dateFormatIncludingTime = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
};